import React from 'react';

const FormationRequestsPurchase = () => {
    return (
        <div>
            
        </div>
    );
};

export default FormationRequestsPurchase;